import { BRAND_GROUPS } from "@/content/media";
import { useLang } from "@/lang";

export default function BrandsPanel() {
  const { isEs } = useLang();
  const lang = isEs ? "es" : "en";

  return (
    <div data-testid="brands-panel" className="mt-16 rounded-3xl border border-hairline bg-cream-2 p-8 sm:p-12">
      <div className="mb-3 flex items-center gap-4">
        <span className="h-px w-10 bg-gold" />
        <p className="text-[11px] font-semibold uppercase tracking-[0.3em] text-gold">
          {isEs ? "Marcas" : "Brands"}
        </p>
      </div>
      <h3 className="font-serif text-3xl font-medium text-navy sm:text-4xl">
        {isEs ? "Reparamos y vendemos:" : "We service and sell:"}
      </h3>
      <p className="mt-3 max-w-2xl text-sm leading-relaxed text-mutedink">
        {isEs
          ? "Si trabaja en su finca, lo atendemos — estas marcas y más."
          : "If it works on your farm, we can handle it — these brands and more."}
      </p>

      <div className="mt-9 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {BRAND_GROUPS.map((g) => (
          <div key={g.key} data-testid={`brands-group-${g.key}`}>
            <p className="text-[11px] font-semibold uppercase tracking-[0.25em] text-gold">
              {g.label[lang]}
            </p>
            <div className="mt-3 flex flex-wrap gap-2">
              {g.brands.map((b) => (
                <span
                  key={b}
                  className="rounded-full border border-hairline bg-white px-3.5 py-1.5 text-[13px] text-navy/80"
                >
                  {b}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
